import React from 'react';
import Select from 'components/Select';
import map from 'lodash/map';

export default function RenderedSelect({
  id,
  placeholder,
  options,
  className,
  meta: { touched, error, warning, valid, pristine },
  input: { value, onBlur, onChange, ...rest },
  disabled = false,
  inputProps
}) {
  return (
    <React.Fragment>
      <Select
        className={className}
        id={id}
        placeholder={placeholder}
        valid={(pristine && !touched) || (touched && valid)}
        onChange={onChange}
        onBlur={() => (onBlur ? onBlur(value) : null)}
        value={value}
        options={
          options &&
          map(options, (option, i) => ({
            value: i,
            label: option
          }))
        }
        disabled={disabled}
        inputProps={inputProps}
      />
      {touched &&
        ((error && <span className="text-danger">{error}</span>) ||
          (warning && <span className="text-warning">{warning}</span>))}
    </React.Fragment>
  );
}
